/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum OpportunityTransactionSubType {
  Backfill = "Backfill",
  AdditionalResource = "AdditionalResource",
  EarlyRollOff = "EarlyRollOff",
  UtilizationChange = "UtilizationChange",
  NewDeal = "NewDeal",
}

export const OpportunityTransactionSubTypeDisplay: Record<OpportunityTransactionSubType, string> = {
  [OpportunityTransactionSubType.Backfill]: "Backfill",
  [OpportunityTransactionSubType.AdditionalResource]: "Additional Resource",
  [OpportunityTransactionSubType.EarlyRollOff]: "Early Roll Off",
  [OpportunityTransactionSubType.UtilizationChange]: "Utilization Change",
  [OpportunityTransactionSubType.NewDeal]: "New Deal",
};
